import React, { useEffect } from 'react';

import styled from '@emotion/styled';

import { TableComponent } from '../components/TableCom';
import { ModalProvider } from '../context/ModalContext';
import { TableRefreshProvider } from '../context/TableRefreshContext';
import useDispatcherList from '../hooks/dispatch/useDispatcherList';
import DipatcherPickList from '../sections/dashboard/dispatch/DipatcherPickList';

const PickList = () => {
  const { getDispatcherList } = useDispatcherList();

  useEffect(() => {
    getDispatcherList();
    // eslint-disable-next-line
  }, []);

  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          <TableComponent
            rigthRevealComponent={DipatcherPickList}
            tableBaseUrl="general-service/v1/picklist"
            tableLabel="Pick List"
            tableHeader={[
              'name',
              'packageCount',
              'warehouseName',
              'status',
              'dispatcherName',
            ]}
            mappingData={{
              name: 'Pick List ID',
              packageCount: 'No of Items',
              warehouseName: 'Area-warehouse Name',
              status: 'Status',
              dispatcherName: 'Assigned Dispatcher',
            }}
          />
        </Container>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default PickList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
